import { useEffect, useState } from "react";
import { api } from "./api.js";

/**
 * Carrega uma imagem que exige autenticação e devolve um blob: URL.
 *
 * POR QUE ISTO EXISTE
 * O portal guarda o token no localStorage e o injeta via interceptor do
 * axios. Isso cobre toda chamada feita por código — e NENHUMA feita pelo
 * próprio navegador. Um `<img src="/api/v1/issues/7/screenshot">` é uma
 * requisição do navegador: ela leva cookies, não leva cabeçalho
 * Authorization. O servidor responde 401 e a imagem aparece quebrada.
 *
 * O sintoma é traiçoeiro porque um `<img>` quebrado continua ocupando
 * espaço e renderizando o `alt` — a tela "parece" certa numa conferência
 * rápida. Só `naturalWidth > 0` prova que os bytes chegaram.
 *
 * A alternativa seria autenticar a rota por cookie, ou assinar URLs
 * temporárias. Buscar com o axios e transformar em blob resolve sem
 * afrouxar o modelo de autenticação nem inventar um segundo mecanismo de
 * credencial só para imagens.
 */
export function useImagemProtegida(url: string | null): {
  src: string | null;
  carregando: boolean;
  erro: unknown;
} {
  const [src, setSrc] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<unknown>(null);

  useEffect(() => {
    if (!url) {
      setSrc(null);
      return;
    }
    let vivo = true;
    let objectUrl: string | null = null;
    setCarregando(true);
    setErro(null);

    api
      .get(url, { responseType: "blob" })
      .then((r) => {
        if (!vivo) return;
        objectUrl = URL.createObjectURL(r.data as Blob);
        setSrc(objectUrl);
      })
      .catch((e) => vivo && setErro(e))
      .finally(() => vivo && setCarregando(false));

    return () => {
      vivo = false;
      // Sem o revoke, cada chamado aberto na triagem deixa uma imagem presa
      // na memória da aba até o recarregamento — e a triagem abre dezenas.
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return { src, carregando, erro };
}
